import { get } from './apiClient';
import type { TenantSettingsResponse } from '../types/branding';

export const settingsApi = {
  get: () => get<TenantSettingsResponse>('/settings'),
};
